import { atom, createStore } from 'jotai'

export const errorIdAtom = atom<string>('')

export const atomStore = createStore()
